import { Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";

function OrderSuccess() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5">
      <div className="text-center">
        <CheckCircle
          size={90}
          className="mx-auto text-green-600"
        />

        <h1 className="text-5xl font-bold text-green-600 mt-5">
          Order Successful
        </h1>

        <p className="text-gray-600 mt-3">
          Thank you for your purchase.
        </p>

        <p className="text-gray-500 mt-2">
          Your order has been placed successfully.
        </p>

        <div className="flex justify-center gap-4 mt-8">
          <Link
            to="/our-product"
            className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg"
          >
            Continue Shopping
          </Link>

          <Link
            to="/buyer/my-orders"
            className="border border-green-600 text-green-600 hover:bg-green-600 hover:text-white px-6 py-3 rounded-lg"
          >
            View Orders
          </Link>
        </div>
      </div>
    </div>
  );
}

export default OrderSuccess;